// Surya Crane Service — actual brand logo image.
// The supplied PNG has a light/white background, so we present it inside a
// soft white rounded panel to keep the mark crisp on dark surfaces.

export const SuryaLogoMark = ({ size = 48, className = "" }) => (
    <span
        className={`relative inline-flex items-center justify-center bg-white ${className}`}
        style={{
            width: size,
            height: size,
            padding: Math.max(2, Math.round(size * 0.06)),
        }}
        aria-hidden="false"
        role="img"
        aria-label="Surya Crane Service"
    >
        <img
            src="/logo.png"
            alt="Surya Crane Service"
            className="w-full h-full object-contain"
            draggable={false}
        />
    </span>
);

export default SuryaLogoMark;
